import { Injectable } from "@angular/core";
import { ApiVisa, Core2Config, PagingResponseModel } from "../shared";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { ClientSidePermissionContainerModel } from "../../../../../models/aggregates/permissions";

@Injectable({
  providedIn: 'root',})
export class TenantPermissionService {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + "permissions"
    apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + "permissions";
    endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + "permissions";
    
    constructor(private httpClient:HttpClient) {
    }

    getClientSidePermissions(appletGuid, tenantCode: string, apiVisa: ApiVisa): Observable<PagingResponseModel<ClientSidePermissionContainerModel>> {
    let url = this.apiUrl + '/login-ep/client-side/' + appletGuid
    if (apiVisa && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/login-ep/client-side/' + appletGuid;
    }
    return this.httpClient.get<PagingResponseModel<ClientSidePermissionContainerModel>>(
        url,
        this.getHttpHeader(apiVisa)
    );
    }

    public getHttpHeader(apiVisa: ApiVisa) {
        apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
        apiVisa.tenantCode = apiVisa.tenantCode
          ? apiVisa.tenantCode
          : '';
    
        const httpOptions = {
          headers: new HttpHeaders({
            authorization: apiVisa.jwt_secret,
            tenantCode: apiVisa.tenantCode, /// this will be removed in the future
            appId: apiVisa.applet_code, /// this will be removed in the future
          })
        };
    
        return httpOptions;
      }
    
}